module.exports = __webpack_public_path__ + "media/images/dividend/ic_anim_check-61bb2d84414066d6c16d715811c30b1d.svg";